module.exports = __webpack_public_path__ + "static/img/marketing.3b68145.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer/marketing.png
// module id = /wCd
// module chunks = 226